function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "256.233 232.646 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    ry: 8,
    style: {
      paintOrder: "fill",
      fill: "rgb(92, 170, 91)"
    },
    y: 232.646,
    x: 256.233,
    transform: "matrix(1, 0, 0, 1, 0, 2.842170943040401e-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 277.71 258.08 L 270.96 258.08 L 270.96 265.05 L 267.44 265.05 L 267.44 247.99 L 278.55 247.99 L 278.55 250.84 L 270.96 250.84 L 270.96 255.24 L 277.71 255.24 Z M 283.56 259.04 L 283.56 265.05 L 280.04 265.05 L 280.04 247.99 L 286.7 247.99 Q 288.62 247.99 290.08 248.69 Q 291.54 249.4 292.32 250.69 Q 293.11 251.99 293.11 253.64 Q 293.11 256.15 291.39 257.59 Q 289.67 259.04 286.64 259.04 Z M 283.56 256.19 L 286.7 256.19 Q 288.09 256.19 288.82 255.54 Q 289.56 254.88 289.56 253.66 Q 289.56 252.41 288.82 251.63 Q 288.08 250.86 286.78 250.84 L 283.56 250.84 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/LogoMenu.d7904851.svg";
export { ForwardRef as ReactComponent };